import {
    trackEvent,
    TrackingObject,
    eventNameConstants,
    stepInteractionConstants,
    interactionTypeConstants,
} from 'dibs-tracking';

import { getCurrentAccountType } from '../../../utils/userTrackingHelpers/getCurrentAccountType';

import { ACTION_COMPLETE } from './sharedAuthTracking';

export function loginTracking({ action, label, value, additional = {} }: TrackingObject): void {
    let currentAccountType;

    if (action === ACTION_COMPLETE) {
        currentAccountType = getCurrentAccountType({ type: 'password' });
        additional = {
            ...additional,
            currentAccountType,
        };
    }

    const ga4Fields: TrackingObject | null =
        action === stepInteractionConstants.STEP_INTERACTION_COMPLETE ||
        action === stepInteractionConstants.STEP_INTERACTION_ENTRY
            ? {
                  eventName: eventNameConstants.EVENT_LOGIN,
                  step_interaction_name: action,
                  interaction_type: interactionTypeConstants.INTERACTION_TYPE_USER_LOGIN,
                  trigger: label || '',
                  step_type: currentAccountType,
              }
            : null;

    trackEvent({
        action: `login ${action}`,
        category: 'login',
        label,
        value,
        additional,
        ...ga4Fields,
    });
}
